<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" id="pop_paymentinfo" style="display:block;">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">결제정보 입력</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <dl class="rew19_select_table">
          <template v-if="mode == 0">
            <dt v-show="!isHidden2"><span class="rew19_table_tit">결제방법</span></dt>
            <dd class="rew19_payment_container rew19_payment_lineup" v-show="!isHidden2">
              <ul class="rew19_clear">
                <li class="rew19_wrapRadio_t1 rew19_lineup_left">
                  <input v-model="paymentType" value="2"
                    type="radio" class="rew19_fakeRadio_t1" id="paymentInfo_type_2"
                         :disabled="paymentType === 2"/>
                  <label for="paymentInfo_type_2">신용카드</label>
                </li>
                <li class="rew19_wrapRadio_t1 rew19_lineup_left">
                  <input v-model="paymentType" value="3"
                    @click="loadCms"
                    type="radio" class="rew19_fakeRadio_t1" id="paymentInfo_type_3"
                         :disabled="paymentType === 3"/>
                  <label for="paymentInfo_type_3">계좌 자동이체</label>
                </li>
              </ul>
            </dd>
          </template>

          <!-- 카드정보 -->
<!--          <card-info-->
<!--            v-show="paymentType == 2"-->
<!--            :class="{'rew19_visible_card': mode == 0}"-->
<!--            :showCardTerm="showCardTerm"-->
<!--            :showInstMonth="showInstMonth"-->
<!--            ref="cardInfoPanel"-->
<!--          >-->
<!--          </card-info>-->
          <!-- //카드정보 -->

          <card-info
            v-if="paymentType == 2 && isHidden2"
            :class="{'rew19_visible_card': mode == 0}"
            :style="{borderTop: mode == 0 ? 'none' : ''}"
            :showCardTerm="showCardTerm"
            :showInstMonth="showInstMonth"
            ref="cardInfoPanel"
          >
          </card-info>

          <card-info
            v-else-if="paymentType == 2 && !isHidden2"
            :class="{'rew19_visible_card': mode == 0}"
            :showCardTerm="showCardTerm"
            :showInstMonth="showInstMonth"
            ref="cardInfoPanel"
          >
          </card-info>

          <dd v-show="paymentType==3" :class="{'rew19_visible_bBook': mode ==0 }"
            class="rew19_visibleOp">
            <div v-show="!viewData.account.bank_account"
              class="rew19_order_box">
              <p></p>
              <span>24년 12월 4일부터 신규 정기구매 자동이체 결제는 지원되지 않습니다.<br>
                신용카드 결제수단으로 등록 부탁드립니다.</span>
            </div>
            <!--              <p>회원님은 자동이체 계좌가 등록되어 있지 않습니다</p>-->
            <!--              <span>-->
            <!--                자동이체 등록은 3일정도 소요되며, 등록완료 자동이체 이용이 가능합니다.<br/>-->
            <!--                (신용카드 결제의 경우 즉시 제품 주문이 가능합니다)<br/>-->
            <!--                자동이체 신청회원은 아래 '자동이체 변경 관리'버튼을 선택하세요-->
            <!--              </span>-->

            <ul v-show="viewData.account.bank_account"
              class="rew19_transition_table">
              <li>
                <span class="with_type1">결제은행</span>
                <div class="txt_type">{{viewData.account.bank_name}}</div>
              </li>
              <li>
                <span class="with_type1">계좌번호</span>
                <div class="txt_type">{{viewData.account.bank_account}}</div>
              </li>
              <li>
                <span class="with_type1">예금주</span>
                <div class="txt_type">{{viewData.account.bank_account_holder}}</div>
              </li>
              <li>
                <em class="with_type1">생년월일</em>
                <div class="rew19_form_full">
                  <input v-model.trim="viewData.account.birth" ref="account.birth"
                    @keypress="numberKeyPress($event)"
                    @keyup="keyUpToNumber($event)"
                    maxlength="6"
                    title="생년월일 입력" type="tel" class="autoFocus rew19_inputTxt_t1" placeholder="주민등록번호 앞 6자리">
                </div>
              </li>
              <li v-if="showReceiptNo">
                <em class="with_type1 nextLine">현금영수증 발급<span>핸드폰 번호</span></em>
                <div class="rew19_form_full">
                  <input
                    v-model.trim="viewData.account.receipt_no" ref="account.receipt_no"
                    title="현금영수증발급 핸드폰번호"
                    type="tel"
                    maxlength="13"
                    class="autoFocus rew19_inputTxt_t1" placeholder="010-0000-0000">
                </div>
              </li>
            </ul>

            <div class="rew19_gepMbleft" v-show="!isHidden">
              <a @click="openBackAccountRegDialog" class="rew19_btn_T1 size_normal">자동이체 변경 관리</a>
            </div>
<!--            기존-->
<!--            <ul class="rew19_dotList topLine">-->
<!--              <li>자동이체 계좌 변경을 하실 경우, 변경까지 영업일 기준 최대 3일정도 소요 되며, 신규 신청은 계좌 등록 완료된 이후 부터 가능 합니다.</li>-->
<!--            </ul>-->
            <ul class="rew19_dotList topLine">
              <strong>
              <li style="color: red;">자동이체 결제를 이용중이신 경우, 24년 12월 31일까지 신용카드 결제로 변경 부탁드립니다.</li>
              <li style="color: red;">25년 1월 1일부터 자동이체 결제 수단으로 등록된 정기구매는 자동철회 됩니다.</li>
              </strong>
            </ul>
          </dd>
        </dl>
      </div><!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div>
    </div>

    <bank-account-reg-dialog
      :show="bankAccountRegDialogShow"
      @close="bankAccountRegDialogClose"
      ref="bankAccountRegDialog"
    ></bank-account-reg-dialog>
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import BankAccountRegDialog from '@/components/popup/BankAccountRegDialog';
import CardInfo from '@/components/control/CardInfo';

import * as ErrMsg from "@/utils/error_msg";
import * as Common from "@/utils/common";

const INIT_VIEW_DATA = {
  card :{
    birth : null,
    expMM : null,
    expYY : null,
    pwd : null,

    useAgree : false,
    isCheckCard : false,

    useTerm : ''
  },
  account:{
    // bank_account: "4280***************"
    // bank_account_holder: "이길준"
    // bank_code: "20"
    // bank_name: "우리은행"
    // birth: "810810"
    // cms_no: "1000046107"
    // cms_status: "1"
    // cms_typ: "A"
    // member_id: "KR0000001",
    bank_account: null,
    bank_account_holder: null,
    bank_code: null,
    bank_name: "-",
    birth: null,
    cms_no: null,
    cms_status: "0",
    cms_typ: "D",
    receipt_no: null,
  }
}

export default {
  name: 'PaymentInfoDialog',
  components: { BankAccountRegDialog, CardInfo },
  extends: AroBase,
  props: {
    show: {
      type: Boolean,
      default: false
    },
    mode: {
      type: Number,
      default : 0 // 0:신용카드/계좌 자동이체, 2:신용카드만, 3:계좌 자동이체만
    },
    //신용카드 동의 사용여부
    showCardTerm : {
      type: Boolean,
      default: false
    },
    //할부개월 사용여부
    showInstMonth : {
      type: Boolean,
      default: false
    },
    //현금영수증 번호 사용여부
    showReceiptNo : {
      type: Boolean,
      default: true
    },
    isHidden: {
      type: Boolean,
      default: false, // 기본값 설정
    },
    isHidden2: {
      type: Boolean,
      default: false, // 기본값 설정
    },
  },
  data() {
    return {
      isHidden: false,
      isHidden2: false,
      paymentType : 2, //2:신용카드, 3:계좌 자동이체,
      currentZIndex : 2000,

      viewData : {
        ...INIT_VIEW_DATA
      },

      rawCms : {},

      //자동이제 계좌 등록/변경
      bankAccountRegDialogShow : false,
      bankAccountRegDialog : {},
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102);
    })
  },
  mounted() {
    let _this = this;

    switch(_this.mode){
    case 0:
    case 2:
      _this.paymentType = 2;
      break;
    case 3:
      _this.paymentType = 3;
      break;
    }
  },
  methods :{
    setVisibility(hidden) {
      this.isHidden = hidden;
    },
    setVisibility2(hidden) {
      this.isHidden2 = hidden;
    },
    onClose(response) {
      let _this = this;
      let retData = null;
      _this.bankAccountRegDialogShow = false;

      if(response){
        if(_this.paymentType == 2){
          retData = {
            paymentType : _this.paymentType,
            card : _this.viewData.card
          };
        }else{
          retData = {
            paymentType : _this.paymentType,
            account : _this.viewData.account
          };
        }
      }

      _this.$emit('close', response, retData);

      _this.viewData = {
        ..._this.viewData,
        ...INIT_VIEW_DATA
      };
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      let _this = this;

      if(_this.paymentType == 2){
        if(!_this.$refs.cardInfoPanel.validateCard()){
          return;
        }

        _this.viewData.card = _this.$refs.cardInfoPanel.getCardInfo();

        //카드 유효성 검사
        let card = _this.viewData.card;
        GibberishAES.size(128);
        let cardInfo = {
          ccard_no : GibberishAES.aesEncrypt(card.cardnumber, _this.$getMemberIdKey()),
          ccard_exp : GibberishAES.aesEncrypt(card.expYY + card.expMM, _this.$getMemberIdKey()),
          birth_dt : card.birth,
          passwd : card.pwd
        };

        _this.viewData.card.isCheckCard = false;

        _this.$showLoading();
        _this.apiCheckCardValidate(cardInfo).then(res=>{

          if (res.status === 200 && res.data.status === "0000") {
            _this.viewData.card.isCheckCard = true;
          }else{
            _this.viewData.card.isCheckCard = false;
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }
        }).catch((err)=>{
          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          //hide loading
          _this.$hideLoading();

          if(_this.viewData.card.isCheckCard){
            _this.onClose(true);
          }
        });

        return;

      }else{
        if(!_this.validateAccount()){
          return;
        };
      }

      this.onClose(true);
    },

    /**
     * API Request
     */
    //CMS 정보 가져오기
    apiGetCms(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_cms`, {
        params: {
          //memberId : memberId
        }
      });
    },

    //카드 유효성 검사
    /**
     * cardInfo : {
     *  카드번호 : ccard_no[1111222233334444]
     *  카드유효기간 : ccard_exp[년/월(1904)]
     *  생년월일 : birth_dt[880101]
     *  비밀번호(앞2자리) : passwd[11]"
     * }
     */
    apiCheckCardValidate(cardInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/check_card_validate`, {
        params: {
          card_list : JSON.stringify([cardInfo])
        }
      });
    },

    /**
     * Local
     */
    initData : function(data){
      let _this = this;

      //UI 초기화
      _this.viewData ={
        ...INIT_VIEW_DATA
      };
      _this.paymentType = data.paymentType;
      if(_this.paymentType == 2){
        _this.viewData.card = {
          ..._this.viewData.card,
          ...data.card
        };

        _this.$refs.cardInfoPanel.initData({card:_this.viewData.card});

      }else if(_this.paymentType == 3){
        _this.loadCms();
      }
    },

    loadCms(){
      let _this = this;

      _this.$showLoading();
      _this.apiGetCms().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.viewData.account = {
            ..._this.viewData.account,
            ...res.data,
            birth : "",
          };

          _this.rawCms = {
            ...res.data
          };
        }else{
          //console.error(res);
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //계좌이체 정보 검증
    validateAccount(){
      let _this = this;
      let accountInfo = _this.viewData.account;
      let chVal = "";

      if(accountInfo.cms_status != "1"){
        _this.$dialogs.alert("등록된 계좌정보가 존재하지 않습니다.")
        .then(res => {});
        return false;
      }

      if(accountInfo.cms_typ != "A"){
        _this.$dialogs.alert("등록 완료된 계좌정보가 존재하지 않습니다.")
        .then(res => {});
        return false;
      }

      //생년월일
      chVal = accountInfo.birth;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("생년월일을 입력해 주십시오.")
        .then(res => {
          _this.$refs["account.birth"].focus();
        });
        return false;
      }

      let regExBirth = /^\d{2}(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
      if(!regExBirth.test(chVal)){
        _this.$dialogs.alert("생년월일을 확인해 주십시오.")
        .then(res => {
          _this.$refs["account.birth"].focus();
        });
        return false;
      }

      //현금영수증 번호
      if(_this.showReceiptNo){
        chVal = accountInfo.receipt_no;
        let regExMobile = /^(?:(010-?\d{4})|(01[1|6|7|8|9]-?\d{3,4}))-?\d{4}$/;
        if(!regExMobile.test(chVal)){
          _this.$dialogs.alert("휴대폰 번호를 확인해 주십시오.")
          .then(res => {
            _this.$refs["account.receipt_no"].focus();
          });
          return false;
        }
      }


      return true;
    },

    //Open Dialog 계좌 등록
    openBackAccountRegDialog(){
      let _this = this;

      _this.$refs.bankAccountRegDialog.initData({
        isExistCms : _this.rawCms.cms_no != ""
      });
      _this.bankAccountRegDialogShow = true;
    },

    //계좌 등록 신청 후 처리
    bankAccountRegDialogClose(isOk, data){
      let _this = this;

      _this.bankAccountRegDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      _this.loadCms();
    },

    /**
     * Util
     */
    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    keyUpToNumber(evt){
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");
    },

  }
}
</script>
<style>
.rew19_payment_oc, .rew19_paymentDon, .rew19_visible_credit, .rew19_visible_card, .rew19_visible_bBook { display: block; }

a.rew19_btn_T1, .rew19_wrapRadio_t1 label{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PaymentInfoDialog.vue